import { render } from "./CreateRequest6.vue?vue&type=template&id=7027494a"
import script from "./CreateRequest6.vue?vue&type=script&lang=js"
export * from "./CreateRequest6.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__